import moment from 'moment';

import FilterSet from '../../utils/FilterSet';

const initalState = {
  jobList: [],
  jobFilterList: new FilterSet(),
  jobSort: {
    prop: '',
    isDesc: false,
  },
  daterange: {
    startDate: moment().subtract(7, 'days'),
    endDate: moment().add(7, 'days'),
  },
  newJob: null,
  varianceData: [],
  data:[],
  workers:[]
};

export const jobsReducer = (state = initalState, action) => {
  switch (action.type) {
    case 'FETCH_JOBS':
      return {
        ...initalState,
        jobList: [...action.payload],
      };
    case 'FETCH_VARIANCE_DATA':
      return {
        ...state,
        varianceData: action.payload,
      };
    case 'FETCH_VARIANCE_CHECKING_PART_NUM_BIN':
      return{
        ...state,
        data: action.payload
      }
    case 'FETCH_VARIANCE_CHECKING_USER_ASSIGNMENTS':
      return {
        ...state,
        workers: action.payload
      }
    case 'UPDATE_JOB_STATUS':
      return {
        ...state,
        jobList: state.jobList.map((job) => {
          if (job.UUID === action.payload.id) {
            return { ...job, status: action.payload.status };
          } else {
            return { ...job };
          }
        }),
      };
    case 'ADD_JOB_FILTER':
      return {
        ...state,
        jobFilterList: new FilterSet(state.jobFilterList.getSet()).add(
          action.payload
        ),
      };
    case 'REMOVE_JOB_FILTER':
      const newFilterSet = state.jobFilterList
        .getSet()
        .filter((filter) => filter.prop !== action.payload.prop);
      return {
        ...state,
        jobFilterList: new FilterSet(newFilterSet),
      };
    case 'ADD_JOB_SORT':
      return {
        ...state,
        jobSort: action.payload,
      };
    case 'CLEAR_JOB_FILTER':
      return {
        ...state,
        jobFilterList: new FilterSet(),
      };
    case 'CLEAR_JOB_SORT':
      return {
        ...state,
        jobSort: { ...initalState.jobSort },
      };
    case 'CLEAR_DATE_RANGE':
      return {
        ...state,
        jobList: [...action.payload.jobList],
        daterange: { ...initalState.daterange },
      };
    case 'CHANGE_DATE_RANGE':
      return {
        ...state,
        jobList: [...action.payload.jobList],
        daterange: { ...action.payload.daterange },
      };
    case 'CREATE_NEW_JOB':
      return {
        ...state,
        jobList: [...state.jobList, action.payload],
      };
    case 'UPDATE_JOB':
      return {
        ...state,
        jobList: state.jobList.map((job) =>
          job.UUID === action.payload.id
            ? { ...job, ...action.payload.job }
            : job
        ),
      };
    case 'ADD_SINGLE_JOB':
      return {
        ...state,
        jobList: [...state.jobList, action.payload],
      };
    case 'UPDATE_DEALER':
      return {
        ...initalState,
      };
    case 'ADD_OR_REMOVE_EMPLOYEE':
      return {
        ...state,
        jobList: state.jobList.map((job) =>
          job.UUID === action.payload.id
            ? {
                ...job,
                countAssignedUsers:
                  job.countAssignedUsers + action.payload.isAddUser,
              }
            : job
        ),
      };
    default:
      return state;
  }
};
